import { useGraphQLQuery } from '@betterment/graphql';

import {
  RecurringTransactionConfigsDocument,
  RecurringTransactionConfigsQuery,
} from './graphql/query.recurringTransactionConfigs.generated';

import { ENVELOPE_ACCOUNT_CASH_TYPE, ENVELOPE_ACCOUNT_MANAGED_TYPE } from '../../../../Shared/constants';

type RecurringTransactionConfigs = Extract<
  RecurringTransactionConfigsQuery['envelopeAccount'],
  { __typename: 'ManagedAccount' }
>['recurringTransactionConfigs'];

type PayrollContributionConfigs = Extract<
  RecurringTransactionConfigsQuery['envelopeAccount'],
  { __typename: 'ManagedAccount' }
>['payrollContributionConfigs'];

export interface RecurringTransactionConfigsQueryResult {
  isLoading: boolean;
  recurringTransactionConfigs?: RecurringTransactionConfigs;
  payrollContributionConfigs?: PayrollContributionConfigs;
  clientId?: string;
  legacySubAccountIds?: number[];
}

export const useRecurringTransactionConfigsQuery = (accountId: string): RecurringTransactionConfigsQueryResult => {
  const { data, loading: isLoading } = useGraphQLQuery(RecurringTransactionConfigsDocument, {
    variables: {
      accountId,
    },
    throwOnError: true,
  });

  const clientId = data?.envelopeAccount?.accountHolders?.[0]?.id;

  const recurringTransactionConfigs =
    data?.envelopeAccount?.__typename === ENVELOPE_ACCOUNT_MANAGED_TYPE
      ? data.envelopeAccount.recurringTransactionConfigs
      : undefined;

  const payrollContributionConfigs =
    data?.envelopeAccount?.__typename === ENVELOPE_ACCOUNT_MANAGED_TYPE
      ? data.envelopeAccount.payrollContributionConfigs
      : undefined;

  const legacySubAccountIds = recurringTransactionConfigs
    ?.map(config =>
      config.source?.__typename === ENVELOPE_ACCOUNT_CASH_TYPE ? config.source.legacySubAccountId : null
    )
    .filter(id => id !== null);

  return {
    isLoading,
    recurringTransactionConfigs,
    payrollContributionConfigs,
    clientId,
    legacySubAccountIds,
  };
};
